import { Checkbox, FormControlLabel, Grid, Typography } from '@mui/material'

import { RolesPicker } from 'components'
import { t } from 'i18n'

export default function ManageRecognitionWhoCanRecognize({ formik, roles }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <RolesPicker
          formik={formik}
          roles={roles}
          label={t('recognitions.fields.whichRolesCanSend')}
          selectLabel={t('recognitions.fields.whoCanRecognize')}
          fieldName='roles_who_can_recognize'
        />
      </Grid>

      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={
                !!formik.values.only_direct_superior_to_subordinate_allowed
              }
              onChange={() =>
                formik.setFieldValue(
                  'only_direct_superior_to_subordinate_allowed',
                  !formik.values.only_direct_superior_to_subordinate_allowed,
                )
              }
              name='only_direct_superior_to_subordinate_allowed'
              color='primary'
              data-cy='onlyDirectSuperiorToSubordinateAllowed'
            />
          }
          label={t(
            'recognitions.fields.onlyDirectSuperiorToSubordinateAllowed',
          )}
        />
        <Typography
          variant='body2'
          color='text.secondary'
          data-cy='onlyDirectSuperiorToSubordinateAllowedHelp'
        >
          {t('recognitions.fields.onlyDirectSuperiorToSubordinateAllowedHelp')}
        </Typography>
      </Grid>
    </Grid>
  )
}
